import VenuePrimaryCTA from './VenuePrimaryCTA';

export default VenuePrimaryCTA;
